<script>
import { Bar } from 'vue-chartjs';
import { toCurrency, commaSeparated } from '@/utils/etc.js';

export default {
	extends: Bar,
	props: {
		graph_datasets: Array,
		is_graph_image: Boolean,
	},
	watch: {
		is_graph_image: {
			handler() {
				if (this.is_graph_image) {
					this.$emit('printGraphImage', this.$refs.canvas.toDataURL('image/png'));
				}
			},
		},
	},
	mounted() {
		let labels = this.graph_datasets.map(el => el.name);
		let datasets = [
			{
				label: 'Qty',
				yAxisID: 'qty',
				backgroundColor: '#6F8CDC',
				data: this.graph_datasets.map(el => el.sum_total_pcs),
			},
			{
				label: 'AvgPCS(1HOUR)',
				yAxisID: 'pcs',
				backgroundColor: '#00FF80',
				data: this.graph_datasets.map(el => el.avg_pcs_per_hour),
			},
			// {
			// 	label: 'AvgTime',
			// 	yAxisID: 'minutes',
			// 	backgroundColor: '#FAA306',
			// 	data: this.graph_datasets.map(el => el.avg_duration),
			// },
		];
		let options = {
			responsive: true,
			maintainAspectRatio: false,
			hover: {
				mode: 'index',
				intersect: false,
			},
			tooltips: {
				mode: 'index',
				intersect: false,
				position: 'bottom',
				xAlign: 'center',
				yAlign: 'bottom',
				callbacks: {
					title: function(tooltipItemList, data) {
						return data['labels'][tooltipItemList[0]['index']];
					},
					label: function(tooltipItem, data) {
						let datasetIndex = tooltipItem.datasetIndex;
						let prefix = data.datasets[datasetIndex].label + ': ';
						let label = toCurrency(tooltipItem.yLabel);
						return prefix + label.substr(0, label.length - 1);
					},
				},
				backgroundColor: '#C4D5FF',
				titleFontSize: 12,
				titleFontColor: '#0066ff',
				bodyFontColor: '#000',
				bodyFontSize: 12,
				displayColors: true,
			},
			scales: {
				yAxes: [
					{
						id: 'qty',
						type: 'linear',
						position: 'left',
						ticks: {
							minRotation: 45,
							callback: value => commaSeparated(value),
						},
					},
					{
						id: 'pcs',
						type: 'linear',
						position: 'right',
						ticks: {
							// max: 100, min: 0
							minRotation: 45,
							callback: value => commaSeparated(value),
						},
						gridLines: {
							display: false,
						},
					},
					// {
					// 	id: 'minutes',
					// 	type: 'linear',
					// 	position: 'right',
					// 	ticks: {
					// 		// max: 100, min: 0
					// 		minRotation: 45,
					// 		callback: value => commaSeparated(value),
					// 	},
					// 	gridLines: {
					// 		display: false,
					// 	},
					// },
				],
			},
			plugins: {
				datalabels: {
					display: false,
				},
			},
		};

		this.renderChart(
			{
				labels,
				datasets,
			},
			options,
		);

		this.$nextTick(() => {
			this.$refs.canvas.style.height = '400px';
		});
	},
};
</script>
